<div class="forecast-details-new-container">
    <div fxLayout="column" fxLayoutAlign="start center">
        <div fxFlex="nogrow" fxLayout="column" fxLayoutGap="20px">
            <div *ngIf="getEntity(forecast)|async as entity" fxLayoutAlign="start center" fxLayoutGap="20px">
                <span class="txt-h-16-7">{{('Resource'|i18n) + ':'}}</span>
                <span class="txt-ec-16-4">{{entity.path|nicePath:false}}</span>
            </div>
            <div fxLayoutAlign="start center" fxLayoutGap="20px">
                <span class="txt-h-16-7"><app-icon
                        name="fal-calendar-alt"></app-icon>&nbsp;{{('Created'|i18n) + ':'}}</span>
                <span class="txt-ec-16-4">{{forecast.forecast_timestamp|i18nTimestamp}}</span>
            </div>
            <div fxLayoutAlign="start center" fxLayoutGap="20px">
                <span class="txt-h-16-7"><app-icon name="fal-stopwatch"></app-icon>&nbsp;{{('Time range'|i18n) + ':'}}</span>
                <div class="bg-4"><span
                        class="txt-ec-16-4">{{forecast.start_time|i18nTimestamp}}</span>
                </div>
                <div class="bg-4"><span
                        class="txt-ec-16-4">{{forecast.end_time|i18nTimestamp}}</span>
                </div>
            </div>

            <div fxLayoutAlign="start center" fxLayoutGap="20px">
                <span class="txt-h-16-7">{{('Strategy'|i18n) + ':'}}</span>
                <span class="txt-ec-16-4">{{(forecast|forecastStrategy) || ('Unknown'|i18n)}}</span>
            </div>
            <ng-container *ngIf="showModels">
                <div *ngIf="getModels(forecast) as models" fxLayoutAlign="start center" fxLayoutGap="20px">
                    <span class="txt-h-16-7">{{('Models'|i18n) + ':'}}</span>
                    <span class="txt-ec-16-4">{{models}}</span>
                </div>
            </ng-container>
        </div>
    </div>
</div>
